import React, { useState, useEffect } from "react";
import "./About.css";

// ====== Image Imports ======
import heroImage from "../Assets/contact.jpg";
import founderImage from "../Assets/founder.jpg";
import craftImage from "../Assets/craft.jpg";
import designImage from "../Assets/design.jpg";
import workshop1 from "../Assets/workshop4.jpeg";
import workshop2 from "../Assets/workshop2.jpg";
import workshop3 from "../Assets/workshop3.jpg";
import heritage1 from "../Assets/heritage1.png";
import heritage2 from "../Assets/heritage2.png";
import heritage3 from "../Assets/heritage3.png";

const About = () => {
    const workshopImages = [workshop1, workshop2, workshop3];
    const heritageImages = [heritage1, heritage2, heritage3];

    const [currentWorkshopImage, setCurrentWorkshopImage] = useState(0);
    const [currentHeritageImage, setCurrentHeritageImage] = useState(0);

    // Rotate Workshop images
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentWorkshopImage((prev) => (prev + 1) % workshopImages.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [workshopImages.length]);

    // Rotate Heritage images
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentHeritageImage((prev) => (prev + 1) % heritageImages.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [heritageImages.length]);

    return (
        <div className="about-page">
            {/* ===== Hero Section ===== */}
            <section className="about-hero">
                <img src={heroImage} alt="About Hero" className="about-hero-img" />
                <div className="about-hero-overlay">
                    <div className="about-hero-card">
                        <h1>About Us</h1>
                    </div>
                </div>
            </section>

            {/* ===== Our Story Section ===== */}
            <section className="our-story">
                <h2>Our Story</h2>
                <hr />
                <div className="story-grid">
                    <div className="story-card">
                        <img src={founderImage} alt="Our Founder" />
                        <h3>1992: Our Founder’s Vision</h3>
                        <p>
                            In 1992, our journey began with a single vision — to craft jewellery
                            that blends timeless beauty with impeccable artistry. Our founder’s
                            dream continues to inspire every creation today.
                        </p>
                    </div>
                    <div className="story-card">
                        <img src={craftImage} alt="Craft & Tradition" />
                        <h3>Craft & Tradition</h3>
                        <p>
                            Our designs are a tribute to the ancient artistry of fine jewellery.
                            Each piece is handcrafted by skilled artisans, preserving traditions
                            passed down through generations.
                        </p>
                    </div>
                    <div className="story-card">
                        <img src={designImage} alt="Design & Legacy" />
                        <h3>Legacies & Design</h3>
                        <p>
                            We combine classic craftsmanship with modern innovation to create
                            designs that symbolize elegance, emotion, and lasting legacy.
                        </p>
                    </div>
                </div>
            </section>

            {/* ===== Our Philosophy Section ===== */}
            <section className="our-philosophy">
                <h2>Our Philosophy</h2>
                <hr />
                <div className="philosophy-card">
                    <div className="philosophy-content">
                        <div className="philosophy-image">
                            <img
                                src={workshopImages[currentWorkshopImage]}
                                alt="Jewellery Workshop"
                            />
                        </div>
                        <div className="philosophy-text">
                            <h4 className="sub-heading">Our Commitment to Excellence</h4>
                            <p>
                                <strong>Uncompromising Quality:</strong> Every creation reflects
                                our dedication to excellence. From sourcing the finest materials
                                to crafting with precision, quality is at the heart of everything we do.
                            </p>
                            <p>
                                <strong>Personal Connection:</strong> Each jewel is a story — a
                                celebration of love, trust, and craftsmanship. We ensure every
                                client’s experience is as meaningful as the jewellery they wear.
                            </p>
                            <p>
                                <strong>Timeless Beauty:</strong> Our designs transcend trends,
                                offering lasting elegance and sophistication for generations to come.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== Our Heritage Section (Order Swapped) ===== */}
            <section className="our-heritage">
                <h2>Our Heritage</h2>
                <hr />
                <div className="heritage-card">
                    <div className="heritage-content">
                        {/* Swapped order: Text first, then Image */}
                        <div className="heritage-text">
                            <h4 className="sub-heading">Legacy Through Generations</h4>
                            <p>
                                Since 1992, Dewalegama Jewellers has been a trusted name in fine jewellery,
                                symbolizing elegance, craftsmanship, and enduring quality. What began as a
                                modest workshop over three decades ago has grown into a renowned establishment
                                known for creating timeless pieces that celebrate life’s most precious moments.
                            </p>
                            <p>
                                Guided by our core values of integrity, excellence, and personal service,
                                we’ve built lasting relationships with generations of customers who continue
                                to place their trust in our artistry. Each piece we craft is more than jewellery —
                                it’s a reflection of love, tradition, and precision.
                            </p>
                            <p>
                                We take pride in embracing sustainable practices and ethically sourced materials,
                                ensuring that our creations shine not only in beauty but also in responsibility.
                                As we move forward, our mission remains steadfast — to honor our rich heritage
                                while evolving with contemporary trends.
                            </p>
                        </div>
                        <div className="heritage-image">
                            <img
                                src={heritageImages[currentHeritageImage]}
                                alt="Heritage"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;